import { InjectionToken } from "@angular/core";
import { LanguageCode } from "./translation.type";
import { isNil } from "lodash";

const LANGUGES: Record<LanguageCode, string> = {
  en: 'English',
  es: 'Spanish',
  pt: 'Portuguese',
  'es-ES': 'Spanish (Spain)',
  'es-LA': 'Spanish (Latin America)',
};

export const LANGUGE: { 
  [key: string]: (args?: any) => string 
} = {
  getLanguageName: ({ code }) => isNil(code) ? 'None' : LANGUGES[code as LanguageCode],
}

export const LanguageToken = new InjectionToken(`LanguageToken`, {
  providedIn: 'root',
  factory: () => LANGUGE
});